export default "__VITE_ASSET__TGUzoQKr__"